import { WorkflowTag, TagResponse, Tag as BackendTag } from "@/generated";
import { Badge } from "@/components/shadcn/badge";
import { resolveColourToken } from "@/utils/colourTokens";

type FlowTagType = WorkflowTag | TagResponse | BackendTag;

export const FlowTag = ({
  tag,
  setIsMenuOpen,
}: {
  tag: FlowTagType;
  setIsMenuOpen?: (value: boolean) => void;
}) => {
  const tagName = "name" in tag ? tag.name : tag.value;
  const token = resolveColourToken(tag.color);

  return (
    <Badge
      variant="outline"
      ellipsis
      className="max-w-32 text-xs rounded-[4px]"
      style={{
        backgroundColor: token.soft,
        color: token.text,
        borderColor: "rgba(0,0,0,0.1)",
      }}
      onClick={setIsMenuOpen ? () => setIsMenuOpen(true) : undefined}
    >
      <span data-label>{tagName}</span>
    </Badge>
  );
};
